import { values } from 'lodash';
import { indexBy, pipe } from 'ramda';
import { Task as ITaskApi } from 'api/tasks';
import { taskNormalizer } from 'data/tasks/schema';
import { CreatableContent, Loaded, Loading } from 'stores/core';
import { TaskField } from 'stores/fields';
import { loadedAllTasks, Task } from 'stores/tasks';
import { toStoreTask } from 'utils/to-store-task';

type FieldId = number;

interface ConstructNormalizedTaskParams {
  taskList?: ITaskApi[];
  fieldList: Record<FieldId, TaskField>;
  isLoading: boolean;
}

type TaskId = number;

export const constructNormalizedTask = ({
  taskList,
  fieldList,
  isLoading,
}: ConstructNormalizedTaskParams): {
  byId: Record<TaskId, CreatableContent<Task>>;
  ids: Loading | Loaded<TaskId[]>;
} => {
  if (!taskList) {
    return { ids: Loading(), byId: {} };
  }
  const {
    entities: { tasks },
  } = taskNormalizer(taskList);
  const to_row = toStoreTask(fieldList, tasks);

  const { payload: allMyTask } = loadedAllTasks(values(tasks).map(to_row));

  return {
    byId: pipe(
      () => allMyTask.map(Loaded),
      indexBy((x) => x[1].taskId),
    )(),
    ids: !isLoading ? Loaded(taskList?.map((task) => task.taskId)) : Loading(),
  };
};
